import Dropdowns from '../../../../components/Dropdowns/Dropdowns';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import './AtaDialog.scss';
export const AtaDialog = ({ onClose }) => {
        const ataChapter = useDropdownConfig(8);
        const ataSection = useDropdownConfig(9);
        const ataParagraph = useDropdownConfig(10);
    return (
        <div className='ata-dialog-component'>
            <div className='dialog-header'>
                <div className='title'>
                    <b>ATA</b>
                    <button className='filled small-size'>
                        + Add ATA
                    </button>
                </div>
                <button className='outlined icon small-size' onClick={onClose}>
                    <i className='icon-cross'></i>
                </button>
            </div>

            <div className='ata-container'>

                {[1,2,3,4].map(i => <div className='ata-item'>
                    <b>{i}. ATA</b>
                    <div className='inputs-container'>
                        <div className='inputs'>

                    <Dropdowns fixedLabel  data={ataChapter.config} />
                    <Dropdowns fixedLabel data={ataSection.config} />
                    <Dropdowns fixedLabel data={ataParagraph.config} />
                        </div>

                    </div>
                    <i className='icon-delete-new'></i>

                </div>)}

            </div>

        </div>
    )
}